<template>
  <transition name="fade">
    <div v-if="popupMessage" id="popup-wrap">
      <div id="popup" class="popup-flex-container">
          <span>{{ popupMessage }}</span>
          <NuxtLink v-if="shouldShowCartLink" to="/cart">
            <i class="fa-solid fa-cart-shopping"></i>&nbsp;
            <span class="popup-link">Go to cart</span>
          </NuxtLink>
      </div>
      <div class="popup-triangle"></div>
    </div>
  </transition>
</template>

<script setup>
import { watch, computed } from 'vue';
import { useUIStore } from '~/store/uiStore';

const uiStore = useUIStore();

// Using computed to always get the current value of uiStore.popupMessage
const popupMessage = computed(() => uiStore.popupMessage);

const shouldShowCartLink = computed(() => {
  return popupMessage.value.includes('Added') && popupMessage.value.includes('to cart');
});

watch(popupMessage, (newVal) => {
  console.log("Popup message changed", newVal);
  if (newVal) {
    setTimeout(() => {
      console.log("Clearing popup message");
      uiStore.setPopupMessage(null); // Using action from uiStore to reset the message
    }, 5000);
  }
});
</script>

<style scoped lang="scss">
@import '~/assets/constants.scss';

#popup-wrap {
  #popup {
    position: fixed;
    right: 1rem;
    background: linear-gradient(to bottom, $fa-orange, $fa-dark-orange);
    color: $light-white;
    top: 50%;
    transform: translateY(-50%); // Centering it vertically
    z-index: 99997;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 1rem;
    border-radius: $fa-border-radius;
    box-shadow: 0 0 0.25rem 0.125rem rgba($black, 0.3);
  }

  .popup-flex-container {
    display: flex;
    flex-direction: column;
  }

  .popup-link {
    color: $fa-blue;
    transition: color 0.3s;

    &:hover {
      color: $fa-light-blue;
    }
  }

  .popup-triangle {
    content: "";
    position: fixed;
    border-left: 24px solid $fa-orange;
    border-right: 12px solid transparent;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%); // Centering the triangle vertically
  }

  a {
    text-decoration: none; // Removes the underline
    color: inherit; // Inherits the parent's text color
    transition: color 0.3s; // Optional: smooth color transition for hover effect

    &:hover {
      color: #fff; // Adjust as necessary
    }
  }
}

// Transition styles
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

</style>
